import * as React from "react";
import Products from "..";
import "../style.css";
import { Stack, Dialog, DialogType, List } from "@fluentui/react";

interface Props {
    order: Order;
    items: ProductGroup[];
    addProducts: (product: Product[]) => void;
    changeAmount: (productNo: string, amount: number) => void;
    debitorPriceRequest: (request: ProductPriceRequest[]) => void;
}

const ProductGroup: React.FunctionComponent<Props> = props => {
    const [showstorage, toggleStorageWindow] = React.useState(false);
    const [storageList, setStorageList] = React.useState<Array<Status>>([]);

    const hideStorageWindow = () => toggleStorageWindow(false);

    const showStorageWindow = (status: Status[]) => {
        toggleStorageWindow(true);
        setStorageList(status);
    };

    const groups = props.items.map((group, index) => {
        if (group.checked) {
            return (
                <div key={index}>
                    <Stack horizontal>
                        <Stack.Item grow={1}>
                            <div className="header__container">
                                {group.name}
                            </div>
                        </Stack.Item>
                    </Stack>
                    <Products
                        addProducts={props.addProducts}
                        changeAmount={props.changeAmount}
                        products={group.items}
                        showStorageWindow={showStorageWindow}
                        debitorPriceRequest={props.debitorPriceRequest}
                        debitorNo={props.order.debitor.no}
                    />
                </div>
            );
        }
    });

    return (
        <div className="product_group__container">
            {groups}
            <Dialog
                hidden={!showstorage}
                onDismiss={hideStorageWindow}
                dialogContentProps={{
                    type: DialogType.close,
                    title: "Lageroversigt"
                }}
                modalProps={{
                    isBlocking: false,
                    containerClassName: "ms-dialogMainOverride"
                }}
            >
                <div className="storage_window__container">
                    <div>
                        <div>Lokation</div>
                        <div>Antal på lager</div>
                    </div>
                    <div>
                        <div>SAMLET</div>
                        <div>
                            {storageList.reduce(
                                (sum, current) => sum + current.amount,
                                0
                            )}{" "}
                            stk.
                        </div>
                    </div>
                    <List items={storageList} onRenderCell={onRenderCell} />
                </div>
            </Dialog>
        </div>
    );
};

const onRenderCell = (item: Status, index: number): React.JSX.Element => {
    return (
        <div className="ms-List-itemCell" data-is-focusable={true}>
            <div>{item.description ? item.description : item.code}</div>
            <div>{item.amount} stk.</div>
        </div>
    );
};

export default ProductGroup;
